/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react';
import { Star } from 'lucide-react';

const RatingStats = ({ aggregates }) => {
  // Destructure aggregated data passed as a prop
  const { totalReviews, averageRating, ratingPercentages } = aggregates;

  // Convert the average rating to a number and format it (e.g., to one decimal)
  const avgRating = parseFloat(averageRating);

  // Create an array of ratings in descending order: 5 stars, 4 stars, etc.
  const ratings = [5, 4, 3, 2, 1];

  return (
    <div className="flex gap-6 items-center">
      {/* Overall Rating */}
      <div className="text-center">
        <h3 className="text-4xl font-bold text-orange-600">
          {avgRating.toFixed(1)}
        </h3>
        <div className="flex justify-center items-center gap-1 text-orange-500 my-1">
          {/* Render filled stars based on the integer part of the average rating */}
          {[...Array(Math.floor(avgRating))].map((_, i) => (
            <Star key={`full-${i}`} className="h-5 w-5 fill-current" />
          ))}
          {/* Optionally, add a half star if needed */}
          {avgRating - Math.floor(avgRating) >= 0.5 && (
            <Star key="half" className="h-5 w-5 fill-current" />
          )}
          {/* Render the remaining as outlined stars */}
          {[...Array(5 - Math.ceil(avgRating))].map((_, i) => (
            <Star key={`empty-${i}`} className="h-5 w-5 stroke-current" />
          ))}
        </div>
        <p className="text-sm">
          <span className="whitespace-nowrap">Course Rating</span>
          <br />
          <span> ({totalReviews} reviews)</span>
        </p>
      </div>

      {/* Rating Bars */}
      <div className="flex flex-col gap-2 w-full">
        {ratings.map(rating => {
          // Get the percentage for this rating; if undefined, default to 0.
          const percent = ratingPercentages[rating] || 0;
          return (
            <div key={rating} className="flex items-center gap-2">
              {/* Render the rating star icons for the label */}
              <div className="flex items-center gap-1 text-orange-500">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`h-4 w-4 ${
                      i < rating ? 'fill-current' : 'stroke-current'
                    }`}
                  />
                ))}
              </div>
              {/* Progress bar */}
              <div className="w-full bg-gray-200 h-2 rounded">
                <div
                  className="bg-primary text-white h-2 rounded"
                  style={{ width: `${percent}%` }}
                ></div>
              </div>
              <span className="text-sm text-gray-600">{percent}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingStats;
